
import React, { Suspense, useEffect, useState } from 'react'
import Banner from "../components/Banner";
import { lazy } from 'react';
const Faq = lazy(() => import("../components/Faq.js"));
const Privileges = lazy(() => import("../components/Privileges.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  const [executed, setExecuted] = useState(false);
  const [syncADL, setSyncADL] = useState(0);
  useEffect(() => {
    
}, []);

         useEffect(() => {
        (function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              (c[a].q = c[a].q || []).push(arguments);
            };
          t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "tjd4nwg3o5");
      }, []);

  return (
    <>
      <Suspense fallback={<>Loading...</>}>
      <Banner />      
      <Privileges />
      <Faq />
      <Footer />
      </Suspense>

    </>
  );
}

export default Homepage;
